module.exports = __webpack_public_path__ + "files/c717b4571f2c12145df3c7bdf5a62bdf.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-7.png
// module id = 1393
// module chunks = 59